import { useContext } from 'react'
import { SCORMContext } from '@contexts/index'

export const useSCORMContext = () => useContext(SCORMContext)
